import { TiCampaignReportView } from '@elva/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/** A campaign's report (staging fix 29 §3.2) — /treatment-intelligence/campaigns/:id/report. */
export function TiCampaignReportPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [period, setPeriod] = usePeriodRange();
  return (
    <TiCampaignReportView
      campaignId={id ?? ''}
      period={period}
      onPeriodChange={setPeriod}
      onBack={() => { void navigate('/treatment-intelligence/campaigns'); }}
      onEdit={() => { void navigate(`/treatment-intelligence/campaigns/${id ?? ''}/edit`); }}
    />
  );
}
